import { defineApiActionTypes } from 'store/common/action-helpers';

const prefix = 'features/users/advisories';

export const FETCH_ADVISORY = defineApiActionTypes(`${prefix}/FETCH_ADVISORY`);

export const FETCH_ADVISORIES_BY_USER_ID = defineApiActionTypes(`${prefix}/FETCH_BY_USER_ID`);

export const SHOW_ACCEPT_ADVISORY_INSTRUCTIONS = `${prefix}/SHOW_ACCEPT_ADVISORY_INSTRUCTIONS`;
export const CHECK_ACCEPT_ADVISORY_STATUS = defineApiActionTypes(
  `${prefix}/CHECK_ACCEPT_ADVISORY_STATUS`
);
export const ACCEPT_ADVISORY = defineApiActionTypes(`${prefix}/ACCEPT_ADVISORY`);

export const REJECT_ADVISORY = defineApiActionTypes(`${prefix}/REJECT_ADVISORY`);

export const SHOW_REVOKE_ADVISORY_INSTRUCTIONS = `${prefix}/SHOW_REVOKE_ADVISORY_INSTRUCTIONS`;
export const REVOKE_ADVISORY = defineApiActionTypes(`${prefix}/REVOKE_ADVISORY`);

export const POLL_ADVISORY = {
  START: `${prefix}/POLL_ADVISORY_START`,
  STOP: `${prefix}/POLL_ADVISORY_STOP`,
};

export const SOFT_ACCEPT_ADVISORY = defineApiActionTypes(`${prefix}/SOFT_ACCEPT_ADVISORY`);
export const SOFT_REJECT_ADVISORY = defineApiActionTypes(`${prefix}/SOFT_REJECT_ADVISORY`);

export const SOFT_VALIDATE_ADVISORY_USING_LINKEDIN = defineApiActionTypes(
  `${prefix}/SOFT_VALIDATE_ADVISORY_USING_LINKEDIN`
);
export const MODIFY_SOFT_ADVISORY_STATUS = `${prefix}/MODIFY_SOFT_ADVISORY_STATUS`;



// WEBPACK FOOTER //
// ./src/store/features/users/advisories/action-types.js